module.exports = __webpack_public_path__ + "static/img/weezie_tasks_compact_blue.bac3c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/weezie_tasks_compact_blue.png
// module id = Mkx1
// module chunks = 0